import { render, staticRenderFns } from "./kpis.vue?vue&type=template&id=34d69570&scoped=true&"
import script from "./kpis.vue?vue&type=script&lang=coffee&"
export * from "./kpis.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d69570",
  null
  
)

export default component.exports